/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bn as Bn,
  rec_CambiarContrasena as CambiarContrasena,
  rec_Hr as Hr,
  rec_IconoMicrosoft as IconoMicrosoft,
  rec_JSXRuntime as JSXRuntime,
  rec_LogoMarca as LogoMarca,
  rec_MarcaCarga as MarcaCarga,
  rec_On as On,
  rec_React as React,
  rec_To as To,
  rec_TransicionMarca as TransicionMarca,
  rec_Vn as Vn,
  rec_Vr as Vr,
  rec_api as api,
  rec_ci as ci,
  rec_cx as cx,
  rec_guardarSesion as guardarSesion,
  rec_refrescarPermisos as refrescarPermisos,
  rec_ii as ii,
  rec_jt as jt,
  rec_obtenerToken as obtenerToken,
  rec_oi as oi,
  rec_sesionVencida as sesionVencida,
  rec_st as st,
  rec_sx as sx,
} from "../../runtime/index.jsx";
export function Login() {
  let e = st(),
    [t] = On(),
    [n, r] = (0, React.useState)(``),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(!1),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(!1),
    [p, m] = (0, React.useState)(!1),
    [h, g] = (0, React.useState)(!1),
    [_, v] = (0, React.useState)(!1),
    [y, b] = (0, React.useState)(`form`),
    [x, S] = (0, React.useState)(null),
    [C, w] = (0, React.useState)(``),
    [T, E] = (0, React.useState)(!0),
    [D, O] = (0, React.useState)(!1),
    [k, A] = (0, React.useState)(!1);
  (0, React.useEffect)(() => {
    try {
      let e = sessionStorage.getItem(`msal_error`);
      e && (l(e), sessionStorage.removeItem(`msal_error`));
    } catch {}
  }, []);
  let j = () => To(t.get(`volver`)) ?? `/`;
  if (obtenerToken() && !sesionVencida() && !h && !_)
    return (0, JSXRuntime.jsx)(jt, {
      to: j(),
      replace: !0,
    });
  if (_)
    return (
      <LogoMarca
        title={`Elegí tu contraseña`}
        subtitle={`La que usaste te la dio un administrador y es temporal.`}
        children={
          <CambiarContrasena
            contrasenaActual={i}
            onListo={() => {
              (v(!1), g(!0));
            }}
          />
        }
      />
    );
  function M(e) {
    if (
      (guardarSesion(e.token, e.usuario),
      Vn(e.tokenConfianza),
      e.usuario?.debeCambiarContrasena)
    ) {
      (v(!0), f(!1));
      return;
    }
    // A dónde entra depende de sus permisos: se leen antes de redirigir.
    refrescarPermisos().finally(() => g(!0));
  }
  async function N(e) {
    (e.preventDefault(), l(``), f(!0));
    try {
      let e = await api(`/auth/login`, {
        method: `POST`,
        body: JSON.stringify({
          usuario: n,
          contrasena: i,
          tokenConfianza: Bn() || void 0,
        }),
        redirigirEn401: !1,
      });
      if (e.token && e.usuario) return M(e);
      if (e.completo?.token) return M(e.completo);
      let t = e.preliminar || e;
      (S({
        correo: t.correo,
        usuario: t.usuario || n,
      }),
        b(`otp`));
    } catch (e) {
      l(e.message || `Ocurrio un error`);
    } finally {
      f(!1);
    }
  }
  async function P() {
    (l(``), m(!0));
    try {
      await sx();
    } catch (e) {
      (l(e.message || `No se pudo iniciar sesion con Microsoft`), m(!1));
    }
  }
  async function F() {
    if (!D) {
      (O(!0), l(``), A(!1));
      try {
        (await api(`/auth/reenviar-otp`, {
          method: `POST`,
          body: JSON.stringify({
            usuario: x.usuario,
          }),
          redirigirEn401: !1,
        }),
          A(!0),
          w(``));
      } catch (e) {
        l(e.message || `No se pudo reenviar el código`);
      } finally {
        O(!1);
      }
    }
  }
  async function I(e) {
    (e.preventDefault(), l(``), A(!1), f(!0));
    try {
      let e = await api(`/auth/verificar-otp`, {
        method: `POST`,
        body: JSON.stringify({
          usuario: x.usuario,
          codigo: C,
          confiar: T,
        }),
        redirigirEn401: !1,
      });
      M(e.token ? e : e.completo);
    } catch (e) {
      l(e.message || `Codigo incorrecto`);
    } finally {
      f(!1);
    }
  }
  return h ? (
    <TransicionMarca
      modo={`abrir`}
      onDone={() =>
        e(j(), {
          replace: !0,
        })
      }
    />
  ) : y === `otp` ? (
    <LogoMarca
      title={`Verificación`}
      subtitle={x?.envioSimulado ? `Modo de prueba: no se envió ningún correo a ${x?.correo ?? `la persona`}. El código lo tiene quien administra el sistema.` : `Ingresá el código que te enviamos a ${x?.correo ?? `tu correo`}`}
      children={
        <form
          className={`mt-6 flex flex-col gap-4`}
          onSubmit={I}
          children={[
            <input
              className={
                cx.replace(`pl-11`, `pl-4`) + ` text-center tracking-[0.5em]`
              }
              value={C}
              onChange={(e) => w(e.target.value.replace(/\D/g, ``).slice(0, 6))}
              inputMode={`numeric`}
              placeholder={`000000`}
              autoFocus={!0}
            />,
            c && (
              <div
                className={`rounded-2xl border border-(--error-border) bg-(--error-bg) p-3`}
                children={
                  <p className={`text-sm text-(--text-h)`} children={c} />
                }
              />
            ),
            k && !c && (
              <div
                className={`rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3`}
                children={
                  <p
                    className={`text-sm text-(--text-h)`}
                    children={`Te enviamos un código nuevo. Revisá tu correo (puede tardar un minuto).`}
                  />
                }
              />
            ),
            <MarcaCarga
              checked={T}
              onChange={E}
              children={`Confiar en este dispositivo por 30 días (no pedir el código de nuevo)`}
            />,
            <button
              type={`submit`}
              disabled={u || C.length < 6}
              className={`flex w-full items-center justify-center gap-2 rounded-full bg-(--accent) py-3 text-sm font-medium text-(--accent-fg) transition hover:opacity-90 disabled:opacity-50`}
              children={[
                u &&
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin`,
                  }),
                `Verificar`,
              ]}
            />,
            <div
              className={`flex items-center justify-between text-xs`}
              children={[
                <button
                  type={`button`}
                  onClick={() => b(`form`)}
                  className={`font-medium text-(--accent) hover:underline`}
                  children={`Volver`}
                />,
                <button
                  type={`button`}
                  onClick={F}
                  disabled={D}
                  className={`font-medium text-(--accent) hover:underline disabled:opacity-50`}
                  children={D ? `Reenviando…` : `Reenviar código`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  ) : (
    <LogoMarca
      title={`Iniciar sesion`}
      subtitle={`Planner de GTH — coordinacion y seguimiento de proyectos`}
      children={
        <form
          className={`mt-6 flex flex-col gap-4`}
          onSubmit={N}
          children={[
            t.get(`expirada`) === `1` && (
              <div
                className={`animar-entrada rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3`}
                children={
                  <p
                    className={`text-sm text-(--text-h)`}
                    children={`Tu sesion expiro. Vuelve a iniciar sesion.`}
                  />
                }
              />
            ),
            <div
              className={`relative`}
              children={[
                (0, JSXRuntime.jsx)(ci, {
                  className: `pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`,
                }),
                <input
                  className={cx}
                  value={n}
                  onChange={(e) => r(e.target.value)}
                  autoComplete={`username`}
                  autoCapitalize={`none`}
                  autoCorrect={`off`}
                  spellCheck={!1}
                  placeholder={`Usuario o correo`}
                  required={!0}
                />,
              ]}
            />,
            <div
              className={`relative`}
              children={[
                (0, JSXRuntime.jsx)(oi, {
                  className: `pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`,
                }),
                <input
                  type={o ? `text` : `password`}
                  className={`${cx} pr-11`}
                  value={i}
                  onChange={(e) => a(e.target.value)}
                  autoComplete={`current-password`}
                  placeholder={`Contrasena`}
                  required={!0}
                />,
                <button
                  type={`button`}
                  onClick={() => s((e) => !e)}
                  className={`absolute right-4 top-1/2 -translate-y-1/2 text-(--text) hover:text-(--text-h)`}
                  aria-label={o ? `Ocultar` : `Mostrar`}
                  children={
                    o ? (
                      <Vr className={`h-4 w-4`} />
                    ) : (
                      <Hr className={`h-4 w-4`} />
                    )
                  }
                />,
              ]}
            />,
            c && (
              <div
                className={`rounded-2xl border border-(--error-border) bg-(--error-bg) p-3`}
                children={
                  <p className={`text-sm text-(--text-h)`} children={c} />
                }
              />
            ),
            <button
              type={`submit`}
              disabled={u || p}
              className={`flex w-full items-center justify-center gap-2 rounded-full bg-(--accent) py-3 text-sm font-medium text-(--accent-fg) transition hover:opacity-90 disabled:opacity-50`}
              children={[
                u &&
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin`,
                  }),
                u ? `Iniciando sesion...` : `Iniciar sesion`,
              ]}
            />,
            <div
              className={`flex items-center gap-3 text-xs text-(--text)`}
              children={[
                <span className={`h-px flex-1 bg-(--border)`} />,
                `o`,
                <span className={`h-px flex-1 bg-(--border)`} />,
              ]}
            />,
            <button
              type={`button`}
              onClick={P}
              disabled={u || p}
              className={`flex w-full items-center justify-center gap-2 rounded-full border border-(--border) bg-(--social-bg) py-3 text-sm font-medium text-(--text-h) transition hover:opacity-80 disabled:opacity-50`}
              children={[
                p ? (
                  (0, JSXRuntime.jsx)(ii, {
                    className: `h-4 w-4 animate-spin`,
                  })
                ) : (
                  <IconoMicrosoft />
                ),
                p ? `Conectando con Microsoft...` : `Continuar con Microsoft`,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
